export default "__VITE_ASSET__vxI6OhSH__"